import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"

const urlCashRegister = "CashRegister"

export const getMovimeintosDolares = async ({ FechaInicio, FechaFinal }) => {
    return axios.get(`${APIURL}/${urlCashRegister}/Transactions/${FechaInicio}/${FechaFinal}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getCorteBusqueda = async ({ FechaBusqueda }) => {
    return axios.get(`${APIURL}/${urlCashRegister}/${FechaBusqueda}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getCorteDetalle = async ({ IdCorteCaja }) => {
    return axios.get(`${APIURL}/${urlCashRegister}/TransactionsUSD/${IdCorteCaja}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const postNewCorte = async ({ TipoCambio }) => {
    return axios.post(`${APIURL}/${urlCashRegister}/Add`,
        {
            TipoCambio
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return getError(Error)
        })
}